import React, { useEffect, useState } from "react";
import { Sidebar } from "primereact/sidebar";
import "./QrCodeView.css";
import arrowback from "../../../../assets/passport/mdi_arrow_back.png";
import { getVoucherDetails } from "src/services/CouponPayment";
import CinemasessionSkeleton from "src/skeletons/CinemasessionSkeleton";
import popcornprofile from "../../../../assets/super-ticket/familyBundle.svg";
import bhexport from "../../../../assets/super-ticket/export.png";
import stBlack from "../../../../assets/super-ticket/superTicket.svg";
import SweetAlert from 'react-bootstrap-sweetalert';
import cross from "../../../../assets/flexi/cross.svg";
import reedmimage from "../../../../assets/kotakpp/redeemed.svg";
import SuperTicketHowItWork from "src/views/superticket/SuperticketHowtowork";








function VoucherHistory({ visible, content, setVisible }) {
  const [vdata, SetVdata] = useState(null);
  const theme = localStorage.getItem("theme");
  const [msg, SetMsg] = useState(null);
  const [loading, SetLoading] = useState(false);
  const isMobile = window.matchMedia("(max-width: 575px)").matches;
  const [showQrDialog, setShowQrDialog] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [voucherImage, setVoucherImage] = useState();
  const [showsupertickethowitwork, setShowsupertickethowitwork] = useState(false);



  const handleMovieClick = (item) => {
    setSelectedItem(item);
    setShowQrDialog(true);
  };
  useEffect(() => {
    if (content?.voucher) {
      SetLoading(true);
      getVoucherDetails(content?.voucher).then((res) => {
        const dt = res.data;
        SetLoading(false);
        if (dt.result === "success") {
          SetVdata(dt.output);
          SetMsg(dt.msg);
        } else {
          SetVdata(null);
        }
      });
    }
  }, [content]);
  return (
    <div>
      <Sidebar
        visible={visible}
        //   icons={proceedbtn}
        showCloseIcon={false}
        style={isMobile ? { height: "100%", width: "100%" } : {}}
        position={isMobile ? "center" : "right"}
        className="voucher-details-popup"
        // className="flexi-terms-cond"
        onHide={() => {
          setVisible(false);
        }}
        dismissable={true}>
        <div className="vhistory-container">
          <div className="passport-right show-in-mobile-view">
            <div className="colse-btn pvr-inox-heading">
              <div className="payment-mobile-header">
                <div className="payment-header-item">
                  <div
                    className="arrow-img"
                    onClick={() => {
                      setVisible(false);
                    }}
                  >
                    <img src={arrowback} alt="Big Image" />
                  </div>
                  <div className="inox-passport">
                    <h2>Voucher Details</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* mobile view */}
          {/*desktop view  */}
          <div className="passport-right show-in-desktop-view">
            <div className="colse-btn pvr-inox-heading">
              <div className="row">
                <div className="col-10">
                  <h3>Voucher Details</h3>
                </div>
                <div className="col-2">
                  <span
                    onClick={() => {
                      setVisible(false);
                    }}
                  >
                    <i
                      className="pi pi-times"
                      style={{ color: "#000", cursor: "pointer" }}
                    ></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          {loading ? (
            <CinemasessionSkeleton />
          ) : (
            <>
              <div className="historuy-voucher">
                {content?.category === "FB" && (
                  <div className="col-md-12 col-sm-12">
                    <div className="st2-wrapper p-2 mt-2"
                      style={{
                        backgroundColor: content?.status === "Redeemed" ? "#989898" : ""
                      }}
                    >

                      {/* TOP DARK HEADER */}
                      <div className="st2-header d-flex align-items-center">
                        <div className="st2-avatar me-2">
                          <img
                            src={content?.logoUrl ? content?.logoUrl : popcornprofile}
                            alt="icon"
                            className="img-fluid st-voucher"
                          />
                        </div>
                        <span className="st2-title">F&amp;B Bundle Code</span>
                      </div>

                      {/* INNER WHITE CARD */}
                      <div className="st2-card position-relative">
                        {content?.status === "Redeemed" && (
                          <img
                            src={reedmimage}
                            alt="Redeemed"
                            className="st2-redeemed position-absolute top-0 end-0"
                          />
                        )}

                        {/* CODE ROW */}
                        <div className="d-flex justify-content-between">
                          <div>
                            <span className="st2-label d-block">CODE NO.</span>
                            <strong>{content?.voucher}</strong>
                          </div>

                          <div className="text-end">
                            <span className="st2-label d-block">CODE VALUE</span>
                            <strong>₹{content?.amount}</strong>
                          </div>
                        </div>

                        {/* VALIDITY */}
                        <div className="mt-2">
                          <span className="st2-label d-block">VALIDITY</span>
                          <strong>
                            {content?.validityFrom} - {content?.expiryDate}
                          </strong>
                        </div>

                        {/* FOOTER: HOW IT WORKS (LEFT) + QR (RIGHT) */}
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          {content?.hiwUrl ? (
                            <span
                              className="st2-link text-decoration-underline"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setShowsupertickethowitwork(true);
                                setVoucherImage(content);
                              }}
                            >
                              How it works?
                            </span>
                          ) : (
                            <span></span>
                          )}

                          <img
                            src={bhexport}
                            alt="QR"
                            className="st2-qr"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleMovieClick(content);
                            }}
                          />
                        </div>

                      </div>
                    </div>
                  </div>
                )}


                {content?.category === "SUPERTICKET" && (
                  <div className="col-md-12 col-sm-12">
                    <div className="st2-wrapper p-2 mt-2"
                      style={{
                        backgroundColor: content?.status === "Redeemed" ? "#989898" : ""
                      }}
                    >
                      {/* TOP DARK HEADER */}
                      <div className="st2-header d-flex align-items-center">
                        <div className="st2-avatar me-2">
                          <img
                            src={content?.logoUrl ? content?.logoUrl : stBlack}
                            alt="Voucher"
                            className="img-fluid st-voucher"
                          />
                        </div>
                        <span className="st2-title">{content?.description}</span>
                      </div>

                      {/* INNER WHITE CARD */}
                      <div className="st2-card position-relative">
                        {content?.status === "Redeemed" && (
                          <img
                            src={reedmimage}
                            alt="Redeemed"
                            className="st2-redeemed position-absolute top-0 end-0"
                          />
                        )}

                        {/* CODE ROW */}
                        <div className="d-flex justify-content-between">
                          <div>
                            <span className="st2-label d-block">CODE NO.</span>
                            <strong>{content?.voucher}</strong>
                          </div>

                          <div className="text-end">
                            <span className="st2-label d-block">CODE VALUE</span>
                            <strong>{content?.strAmountDesc}</strong>
                          </div>
                        </div>

                        {/* VALIDITY */}
                        <div className="mt-2">
                          <span className="st2-label d-block">VALIDITY</span>
                          <strong>
                            {content?.validityFrom} - {content?.expiryDate}
                          </strong>
                        </div>

                        {/* FOOTER: HOW IT WORKS + QR */}
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          {content?.hiwUrl ? (
                            <span
                              className="st2-link text-decoration-underline"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setShowsupertickethowitwork(true);
                                setVoucherImage(content);
                              }}
                            >
                              How it works?
                            </span>
                          ) : (
                            <span></span>
                          )}

                          <img
                            src={bhexport}
                            alt="QR"
                            className="st2-qr"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleMovieClick(content);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {vdata &&
                  vdata.map((item, idx) => {
                    return (
                      <>
                        {/* mobile view */}

                        <div className="vhistory-box mt-3">
                          <div className="vhistory-item">
                            <span className="vhistory-label">
                              Redeemed Time
                            </span>
                            <span className="vhistory-value">
                              {item?.transactionTime}
                            </span>
                          </div>
                          {content?.category !== "SUPERTICKET" && (
                            <div className="vhistory-item">
                              <span className="vhistory-label">
                                Validity (1 Day)
                              </span>
                              <span className="vhistory-value">
                                {item?.expiryDate}
                              </span>
                            </div>)}
                          <div className="vhistory-item">
                            <span className="vhistory-label">{content?.category === "SUPERTICKET" ? "Cinema" : "Location"}</span>
                            <span className="vhistory-value">
                              {item?.theatreName}
                            </span>
                          </div>
                          <div className="vhistory-item">
                            <span className="vhistory-label">
                              Amount Redeemed
                            </span>
                            <span className="vhistory-value">
                              ₹{parseFloat(item?.discount || 0).toFixed(2)}
                            </span>
                          </div>
                          {content?.category !== "SUPERTICKET" && (
                            <div className="vhistory-item">
                              <span className="vhistory-label">
                                Balance Amount
                              </span>
                              <span className="vhistory-value">
                                ₹{parseFloat(item?.balAmount).toFixed(2)}
                              </span>
                            </div>
                          )}
                        </div>
                      </>
                    );
                  })}

                {vdata && vdata?.length == 0 ? (
                  <>
                    <div className="vhistory-box mt-3">
                      <div className="fail-msg-box">
                        <div className="row">
                          <div className="col d-flex justify-content-center align-items-center">
                            <p
                              dangerouslySetInnerHTML={{
                                __html: msg,
                              }}
                            ></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </>
          )}
        </div>
      </Sidebar>
      <SweetAlert
      title=''
        custom={true}
        showCloseIcon={true}
        customIcon={
          <div className="flexi-cross-how">
            <img
              src={cross}
              alt="Close"
              className="img-fluid"
              onClick={() => setShowQrDialog(false)}
            />
          </div>
        }
        show={showQrDialog}
        confirmButtonText={false}
        showCancelButton={false}
        heightAuto={true}
        closeOnClickOutside={true}
        onConfirm={() => setShowQrDialog(false)}
        onCancel={() => setShowQrDialog(false)}
        confirmBtnCssClass={
          theme === "inoxTheme"
            ? "confirm-btn-inox border-0 super-ticket-btn d-none"
            : "confirm-btn-pvr border-0 super-ticket-btn d-none"
        }
      >
        {/* Move your QR image into the children instead of customIcon */}
        <div className="qr-image-container text-center">
          <img
            src={`data:image/png;base64,${selectedItem?.qrImage}`}
            alt="Voucher QR"
            className="img-fluid"
          />
        </div>
      </SweetAlert>
      <SuperTicketHowItWork
        visible={showsupertickethowitwork}
        content={voucherImage}
        setVisible={setShowsupertickethowitwork}
      />
    </div>
  );
}

export default VoucherHistory;
